export const DEV_SSE_EVENT_NAME = 'homesight:dev-sse-event';

const TIMESTAMP_FIELD_PATTERN = /(timestamp|time|date)/i;

const isCurrentTimeCandidate = (key, value) => {
  if (!TIMESTAMP_FIELD_PATTERN.test(key)) {
    return false;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (typeof value === 'string') {
    return !Number.isNaN(Date.parse(value));
  }

  return false;
};

export const refreshDevSseEventTimestamps = (eventPayload, currentDate = new Date()) => {
  const currentEpochTime = currentDate.getTime();
  const currentIsoTimestamp = currentDate.toISOString();

  const transformValue = (value, key = '') => {
    if (Array.isArray(value)) {
      return value.map((item) => transformValue(item));
    }

    if (value && typeof value === 'object') {
      return Object.entries(value).reduce((result, [entryKey, entryValue]) => {
        result[entryKey] = transformValue(entryValue, entryKey);
        return result;
      }, {});
    }

    if (!isCurrentTimeCandidate(key, value)) {
      return value;
    }

    return typeof value === 'number' ? currentEpochTime : currentIsoTimestamp;
  };

  return transformValue(eventPayload);
};

export const emitDevSseEvent = (eventPayload) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(DEV_SSE_EVENT_NAME, {
      detail: eventPayload,
    })
  );
};
